module.exports = __webpack_public_path__ + "static/headerRightBg-93f1d403d4952862496941f15061ca1b.png";